var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { print } from '@0no-co/graphql.web';
import { buildRequestHeaders, } from './buildRequestHeaders';
/**
 * Builds the request initialization object for a GraphQL query towards DatoCMS
 * Content Delivery API.
 *
 * @return {RequestInit} The built request initialization object
 */
export function buildRequestInit(
/** The GraphQL query to execute */
query, 
/** Execution options, including API token and variables for query execution */
options) {
    var stringifiedQuery = typeof query === 'string' ? query : print(query);
    return __assign({ method: 'POST', headers: buildRequestHeaders(options), body: JSON.stringify({
            query: stringifiedQuery,
            variables: options === null || options === void 0 ? void 0 : options.variables,
        }) }, options === null || options === void 0 ? void 0 : options.requestInitOptions);
}
//# sourceMappingURL=buildRequestInit.js.map